import React, { useState, createContext } from "react";

// AuthContext
const AuthContext = createContext({
  token: "",
  email: "",
  userProfile: {},
  isLoggedIn: false,
  getIdToken: () => {},
  login: (token) => {},
  logout: (token) => {},
  giveProvider: () => {},
  giveToken: () => {},
  giveEmail: () => {},
  // Adding ApiContext properties
  baseUrl: "",
  setUseNewApi: () => {},
  useNewApi: false
});

const isTokenValid = (token) => {
  try {
    const decodedJwt = JSON.parse(atob(token.split(".")[1]));
    if (decodedJwt.exp * 1000 > Date.now()) {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
};

export const AuthContextProvider = (props) => {
  const initialToken = localStorage.getItem("token");
  const [token, setToken] = useState(initialToken);
  const [email, setEmail] = useState("");
  const [userProfile, setProfile] = useState();
  const [provider, setProvider] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(!!token);

  // Step 1: Get the stored API type from localStorage or fallback to false
  // const storedApiUrl = localStorage.getItem('tenant');
  // const defaultApiUrl = process.env.REACT_APP_favApi;
  // const defaultNewApiUrl = process.env.REACT_APP_favApi_New;

  // Determine initial useNewApi based on stored tenant
  // const initialUseNewApi = storedApiUrl === defaultNewApiUrl;
  // const [useNewApi, setUseNewApi] = useState(initialUseNewApi); // false for old API

  // Step 2: Compute baseUrl based on useNewApi
  // const baseUrl = useNewApi ? defaultNewApiUrl : defaultApiUrl;

  // Step 3: Persist baseUrl to localStorage when useNewApi changes
  // React.useEffect(() => {
  //   localStorage.setItem('tenant', process.env.REACT_APP_favApi_New);
  //   // localStorage.setItem("isNewTenant",useNewApi)
  //   //eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [baseUrl]);

  const gigya = window.gigya;

  const loginHandler = (token, provider, userProfile, idToken, email) => {
    setToken(token);
    setProvider(provider);
    setProfile(userProfile);
    setIsLoggedIn(true);
    setEmail(email);
    localStorage.setItem("token", token);
    localStorage.setItem("idToken", idToken);
    localStorage.setItem("email", userProfile?.email);
    localStorage.setItem("stringEmail", JSON.stringify(userProfile?.email));
    localStorage.setItem("userProfile", JSON.stringify(userProfile));
    // localStorage.setItem('tenant', process.env.REACT_APP_favApi_New);
    // // localStorage.setItem("isNewTenant", false);
    // setUseNewApi(false);
  };

  const logoutHandler = () => {
    setToken(null);
    setEmail(null);
    setProvider(null);
    setProfile(null);
    setIsLoggedIn(false);
    localStorage.removeItem("token");
    localStorage.removeItem("idToken");
    localStorage.removeItem("email");
    localStorage.removeItem("stringEmail");
    localStorage.removeItem("userProfile");
    localStorage.removeItem("columnForGlobal");
    localStorage.removeItem("columnForMarket");
    localStorage.removeItem("columnForRetailer");
    // localStorage.removeItem("tenant")
    // localStorage.removeItem("isNewTenant")
    localStorage.removeItem("countryFilter")
    localStorage.removeItem("retailerFilter")
    localStorage.removeItem('show_all_data_market_state');
    localStorage.removeItem('show_all_data_retailer_state');
    localStorage.removeItem("LOV_FILTER_VALUE");
     localStorage.removeItem("toggleStateMarket")
    localStorage.removeItem("toggleStateRetailer")
    localStorage.removeItem("retailerOption")
  };

  const giveProvider = () => {
    return provider;
  };
  const giveToken = () => {
    return token;
  };
  const giveEmail = () => {
    return email;
  };
  const getIdToken = () => {
    return new Promise((resolve, reject) => {
      const storedToken = localStorage.getItem("idToken");
      if (storedToken && isTokenValid(storedToken)) {
        resolve(storedToken);
      } else {
        gigya.accounts.getJWT({
          UID: token,
          callback: function (response) {
            if (response.id_token) {
              localStorage.setItem("idToken", response.id_token);
              resolve(response.id_token);
            } else {
              setIsLoggedIn(false);
              reject(response);
            }
          }
        });
      }
    });
  };

  const contextValue = {
    token: token,
    email: email,
    userProfile: userProfile,
    isLoggedIn: isLoggedIn,
    login: loginHandler,
    getIdToken: getIdToken,
    logout: logoutHandler,
    giveProvider: giveProvider,
    giveToken: giveToken,
    giveEmail: giveEmail,
    // Adding API Context properties to the context value
    baseUrl: process.env.REACT_APP_favApi_New,
    // useNewApi: useNewApi,
    // setUseNewApi: setUseNewApi
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
